import React, {useState} from 'react';
import styled from 'styled-components';
import {COLORS, SIZES} from '../styleVars';
import {Typography} from '../typography/Typography';

const Container = styled.div`
  position: relative;
  z-index: 70;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  height: ${SIZES['24']};
  padding: 0 ${SIZES['16']};

  input {
    -webkit-tap-highlight-color: transparent;
    position: absolute;
    width: ${SIZES['24']};
    height: ${SIZES['24']};
    margin: 0;
    padding: 0;
    opacity: 0;
    cursor: pointer;
  }
`;

const CheckboxIcon = styled.div`
  margin-right: ${SIZES['8']};
  height: ${SIZES['24']};
  width: ${SIZES['24']};
`;

const Svg = styled.svg`
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: ${SIZES[24]};
  flex-shrink: 0;
`;

interface CheckboxProps {
  /**
   * Whether the checkbox is initially checked or not.
   */
  initiallyChecked?: boolean;
  /**
   * callback when the Checkbox is toggled
   */
  onToggle: (state: boolean) => void;
  /**
   * The label is shown next to the checkbox and describes the action.
   */
  label?: string;
  /**
   * tab-index of the Checkbox, used to customize focus-order
   */
  tabIndex?: number;
  /**
   * @ignore
   */
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  initiallyChecked = false,
  label = '',
  onToggle,
  tabIndex = 0,
  className,
}) => {
  const [checked, setChecked] = useState(initiallyChecked);

  const handleClick = () => {
    setChecked(!checked);
    onToggle(!checked);
  };

  const displayedIcon = checked ? (
    <Svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' style={{color: COLORS.fupaSecondary}}>
      <path d='M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' />
    </Svg>
  ) : (
    <Svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' style={{color: COLORS.grey}}>
      <path d='M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' />
    </Svg>
  );

  return (
    <Container className={className}>
      <Row onClick={handleClick}>
        <input tabIndex={tabIndex} type='checkbox' />
        <CheckboxIcon>{displayedIcon}</CheckboxIcon>
        <Typography variant='body1' component='label'>
          {label}
        </Typography>
      </Row>
    </Container>
  );
};

export {Checkbox};
